import SetlistContentRow from './SetlistContentRow'

export default SetlistContentRow
